{
  "schemaVersion": 1,
  "id": "shymkent",
  "officialCityId": "790000000",
  "names": {
    "ru": "Шымкент",
    "kk": "Шымкент",
    "en": "Shymkent"
  },
  "aliases": ["Шымкент", "Чимкент"],
  "bboxId": "shymkent-city",
  "graphId": "shymkent-city",
  "bbox": {
    "south": 42.08,
    "west": 69.27,
    "north": 42.51,
    "east": 69.97
  },
  "origin": {
    "lat": 42.295,
    "lon": 69.62
  },
  "view": {
    "center": [69.59, 42.315],
    "zoom": 11.5
  },
  "time": {
    "zone": "Asia/Almaty",
    "utcOffsetMin": 300
  },
  "source": {
    "pbf": "data/pbf/kazakhstan-latest.osm.pbf",
    "extract": "data/pbf/shymkent-city.osm.pbf",
    "sha256": "53a639fc0cfdb786089050ba4c18c8a25ed91f7758ec71d934a0257a7d056495",
    "replicationTimestamp": "2026-10-11T20:21:06Z",
    "extractObjectTimestamp": "2026-10-11T17:39:01Z"
  },
  "generatedAt": "2026-10-11T17:39:01Z",
  "routingPolicy": "kz-car-assumptions-v1",
  "compiler": {
    "highwayPolicy": "motorway-as-trunk-v1",
    "signalCollapseM": 30
  },
  "model": {
    "demandPolicy": "buildings-v1",
    "multiplier": 0.04,
    "calibrationStatus": "unvalidated-transfer",
    "seeds": [1, 2],
    "warmupMinutes": 10,
    "firstSlotMin": 360,
    "slotMinutes": 30,
    "slotCount": 32
  },
  "features": {
    "lanes": true,
    "decks": true,
    "lanePath": true,
    "traffic": true,
    "landmarks": false,
    "ownBuildings": true,
    "transit": false,
    "busRouting": false,
    "cameras": false,
    "overture": false,
    "tripProfiles": false
  },
  "budgets": {
    "archivesBytes": 40000000,
    "trafficBytes": 8000000,
    "lanesBytes": 20000000,
    "decksGzipBytes": 1500000,
    "nativeSetBytes": 63000000,
    "buildRssGiB": 24,
    "maxWorkers": 4,
    "citySetBytes": 150000000
  },
  "bboxes": {
    "small": {
      "id": "shymkent-small",
      "title": "Шымкент: центр (тестовый квадрат)",
      "south": 42.29,
      "west": 69.56,
      "north": 42.335,
      "east": 69.62,
      "tilesPerSide": 1
    },
    "city": {
      "id": "shymkent-city",
      "title": "Шымкент целиком",
      "south": 42.08,
      "west": 69.27,
      "north": 42.51,
      "east": 69.97,
      "tilesPerSide": 8
    }
  },
  "auditRegions": {
    "center": {
      "south": 42.29,
      "west": 69.56,
      "north": 42.335,
      "east": 69.62
    }
  },
  "assumptions": [
    "Перенесено из Алматы без проверки по поездкам Шымкента: спрос зданий buildings-v1, множитель 0,04, суточная кривая SimConfig.",
    "Перенесено из Алматы: эвристика часов, пустая часовая калибровка, пределы местных улиц 30/40/20/15 км/ч, стоимость классов и модель выездов.",
    "Задержки светофоров 10/15/20 с, справа ×0,5, service entry 15 с — справочные допущения.",
    "D44: полное ожидание на светофорах после модельных линков, множители скоростей 1; допущение, не измерение Шымкента.",
    "Схлопывание стоп-линий 30 м — перенесённое допущение.",
    "Motorway → trunk, motorway_link → trunk_link; исходные OSM-теги сохранены, класс имеет provenance default.",
    "Транспорт, камеры, ориентиры, Overture и профили поездок отключены."
  ],
  "status": "live"
}
